export default __webpack_public_path__ + "static/media/facebook.fbbe6423.svg";